// extracted by mini-css-extract-plugin
export default {"header":"Reports_header__9agi1","row":"Reports_row__7Q0zl","column":"Reports_column__ZxH-Y"};